import axios from 'axios'
import { PRODUCTION, DEVELOPMENT, TEST } from '../../constants/env'
import {
  PRODUCTION_ENDPOINT,
  DEVELOPMENT_ENDPOINT,
  TEST_ENDPOINT
} from '../../constants/endpoints'
import store from '@/store'
import router from '@/router'

function getDefaultUrl (env = DEVELOPMENT) {
  switch (env.toLowerCase()) {
    case PRODUCTION: return PRODUCTION_ENDPOINT
    case DEVELOPMENT: return DEVELOPMENT_ENDPOINT
    case TEST: return TEST_ENDPOINT
    default: return DEVELOPMENT_ENDPOINT
  }
}

axios.defaults.baseURL = getDefaultUrl(process.env.NODE_ENV)
console.log('base url', axios.defaults.baseURL)

axios.interceptors.request.use(config => {
  const token = store.getters['auth/getToken']
  if (token) config.headers.Authorization = token
  // config.headers.Authorization = `eyJhbGciOiJSUzI1NiIsImtpZCI6IjYyMDg0NmQxNDVjN2VjNjQ0ODU5MmFjZWYzMGVhYmE1NzA4NmMwYWUifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vaW5zaWRlaW5zaWdodHN0YXBsZXMiLCJhdWQiOiJpbnNpZGVpbnNpZ2h0c3RhcGxlcyIsImF1dGhfdGltZSI6MTUyOTY0NDA0NCwidXNlcl9pZCI6ImQ0S2E5Q01HWklPM055ZUU1SHhzUW9MT01uOTMiLCJzdWIiOiJkNEthOUNNR1pJTzNOeWVFNUh4c1FvTE9NbjkzIiwiaWF0IjoxNTI5NjQ0MDQ0LCJleHAiOjE1Mjk2NDc2NDQsImVtYWlsIjoidGFydW4uc3V2dmFkYUBpbXBhY3RhbmFseXRpY3MuY28iLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsidGFydW4uc3V2dmFkYUBpbXBhY3RhbmFseXRpY3MuY28iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.qwQ2NOd7D-lV8o3uNjYMZRjBByD-NxXHcGmOlSermvtGgmJvM-t471F5PMAJg7gCATeQ_yY1aOCMbDV3IV4pRn-e85K_YIXpu8Xmuj8SHqB3oBgIbP75QhYfsQ66TmJwttBU1CBNPWjyIMU8BZ6TElVWTyRMg7H56qiDLO3U8rU7RonF1ATfCVFdMxBougakkhcLlge917RLuRlwJ5jGBwbCcfMbbBR-7nBlBGz0ZGJLKfo3wqE4h0UAk0L2R7_wK7qXMb6nLPeeH0A0nl-Jc2PSe04TL15YjauV_JZQ3VSu_-hzHhVjC6SVV1qOQEK8gQQi9vT8HYa4FdAnwS0nRQ`
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  const errorObject = {
    code: error.response.status,
    ...error.response.data
  }
  store.state.auth.errors = errorObject
  if (errorObject.code === 401) {
    window.localStorage.removeItem('hashed-entitles')
    router.push('/')
  }
  // Do something with response error
  return Promise.reject(errorObject)
})

export default function api ({url, method, data = null, params = {}}) {
  console.log('base url1', axios.defaults.baseURL)
  const requestConfig = (data === null) ? {url, method, params} : {url, method, data, params}
  return new Promise((resolve, reject) => {
    axios.request(requestConfig)
      .then(res => resolve(res.data))
      .catch(err => reject(err))
  })
}



// WEBPACK FOOTER //
// ./src/services/apiHelper/index.js